import { type FC, Suspense, lazy } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";

export function lazify(dynamicImport: () => Promise<{ default: FC }>) {
	const Component = lazy(dynamicImport);
	return () => (
		<ErrorBoundary FallbackComponent={FallbackComponent}>
			<Suspense>
				<Component />
			</Suspense>
		</ErrorBoundary>
	);
}
const reload = () => location.reload();
const preStyle = { tabSize: "4ch", whiteSpace: "pre-wrap" };

function FallbackComponent(props: FallbackProps) {
	return (
		<p role="alert">
			<div>
				Failed to render the component due to the following error. It is
				recommended you save your changes and reload the page.
			</div>
			<pre style={preStyle}>{String(props.error)}</pre>
			<button className="btn btn-danger" type="button" onClick={reload}>
				Reload Page
			</button>
		</p>
	);
}
